import { connect } from "react-redux";
import { selectCurrentModalWithType } from "../../selectors/selectCurrentModalWithType";
import { componentWithProps } from "../generic/componentWithProps";
import { TypeModal } from "../modals/TypeModal";
export var TransparentDialogManagerDOM = connect(selectCurrentModalWithType(TypeModal.TransparentDialog))(componentWithProps);



//////////////////
// WEBPACK FOOTER
// ./src/features/transparent-dialog/TransparentDialogManagerDOM.tsx
// module id = 1369
// module chunks = 3